module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/babel-runtime@6.26.0/~/babel-runtime/regenerator/index.js
// module id = s/F+
// module chunks = 5